// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"52a65648","117":"52a65648","199":"52a65648","523":"52a65648","568":"52a65648","652":"52a65648","679":"7a0a9090","771":"11381244","842":"da9c7b98","938":"52a65648"}[chunkId] + ".chunk.css";
};